export default __webpack_public_path__ + "static/media/booth5.67e16023.png";